import TextField from '@mui/material/TextField';
import { useState, useImperativeHandle, forwardRef } from 'react';
import { useTranslation } from 'react-i18next';

const ProductIdSearch = forwardRef((_props, ref) => {
  const { t } = useTranslation();

  const [value, setValue] = useState<string>('');

  useImperativeHandle(ref, () => ({
    getValue: () => {
      return { productId: value };
    },
  }));

  return (
    <TextField
      fullWidth
      data-testid="searchby_productId"
      label={t('QC_V2.QC_LST.PRODUCT_ID')}
      variant="outlined"
      placeholder={t('QC_V2.QC_LST.PRODUCT_ID')}
      InputLabelProps={{
        shrink: true,
      }}
      value={value}
      onChange={(e) => setValue(e.target.value)}
    />
  );
});

ProductIdSearch.displayName = 'ProductIdSearch';

export default ProductIdSearch;
